export default "__VITE_ASSET__ac77a043__"